import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    titulo: '',
    subtitulo: '',
    user: '',
    user1: false,
    aviso: '',
    logout: '',
    load: false,
    load1: false,
    toast: '',
    option: '',
    option1: false,
    sttions: '',
    sttions1: false,
    paises: [],
    paises1: false,
    lang: 'GB',
    cars: [],
    cars1: false,
    mapa: false,
    drivers: [],
    drivers1: false
  },
  getters: {
    getOptionCompany (state) {
      return state.option.company
    }
  },
  mutations: {
    SET_MAP (state, a) {
      state.mapa = a
    },
    SET_LANG (state, a) {
      state.lang = a
    },
    SET_TITULO (state, a) {
      state.titulo = a
    },
    SET_SUBTITULO (state, a) {
      state.subtitulo = a
    },
    SET_USER (state, a) {
      state.user1 = true
      state.user = a
    },
    SET_AVISO (state, a) {
      state.aviso = a
    },
    SET_LOGOUT (state, a) {
      state.logout = a
      state.user = ''
    },
    SET_LOAD (state, a) {
      state.load = a || false
    },
    SET_LOAD1 (state, a) {
      state.load1 = a || false
    },
    SET_TOAST (state, a) {
      state.toast = a
    },
    SET_OPTIONS (state, a) {
      state.option = a
    },
    SET_OPTIONS1 (state, a) {
      state.option1 = a
    },
    // atualiza so uma chave do option
    SET_OPTION (state, a) {
      state.option = Object.assign({}, state.option, a)
    },
    SET_STATIONS (state, a) {
      state.stations = a
    },
    SET_STATIONS1 (state, a) {
      state.stations1 = a
    },
    SET_PAISES (state, a) {
      state.paises = a
      state.paises1 = true
    },
    SET_CARS (state, a) {
      state.cars = a
      state.cars1 = true
    },
    SET_DRIVER (state, a) {
      state.drivers = a
      state.drivers1 = 1
    }
  }
})
